<template>

<div class="login-page">

<div class="login-card">

<!-- LOGO -->

<div class="logo-section">

<img
src="https://luinnycorporanapp.net/luinnycorporan/storage/uploads/Logo4_20260302082457.png"
class="logo"
/>

</div>

<h2 class="title">
Bienvenido de nuevo
</h2>

<p class="subtitle">
Inicia sesión para continuar tu experiencia musical.
</p>

<form @submit.prevent="loginUser">

<div class="input-group">

<label>Correo electrónico</label>

<input
type="email"
v-model="email"
required
/>

</div>

<div class="input-group">

<label>Contraseña</label>

<div class="password-box">

<input
:type="showPassword?'text':'password'"
v-model="password"
required
/>

<span
class="eye"
@click="showPassword=!showPassword"
>

👁

</span>

</div>

</div>

<button 
class="login-btn"
:disabled="isProcessing"
>

<span v-if="!isProcessing">
Acceso
</span>

<span v-if="isProcessing" class="btn-processing">
Iniciando sesión...
</span>

</button>

</form>

<div class="auth-links">

<router-link to="/forgot-password">

¿Has olvidado tu contraseña?

</router-link>

<router-link to="/register">

Crear una cuenta

</router-link>

</div>

</div>


<!-- SUCCESS MODAL -->

<div
v-if="showWelcome"
class="welcome-overlay"
>

<div class="welcome-card">

<div class="avatar-ring">

<img
v-if="user.profile_image"
:src="user.profile_image"
class="welcome-avatar"
/>

<img
v-else
src="https://luinnycorporanapp.net/luinnycorporan/storage/uploads/Logo4_20260302082457.png"
class="welcome-avatar"
/>

</div>

<div class="success-icon">

<svg viewBox="0 0 52 52">

<circle cx="26" cy="26" r="25"/>

<path d="M14 27 L22 35 L38 18"/>

</svg>

</div>

<h2 class="welcome-title">

Bienvenido de nuevo

</h2>

<h3 class="welcome-user">

{{user.name}}

</h3>

<p class="welcome-text">

Inicio de sesión correcto.

Preparando tu experiencia.

</p>

<div class="progress">

<div class="progress-fill"></div>

</div>

<p class="redirect-text">

Cargando tu panel de control...

</p>

</div>

</div>

</div>

</template>
<script>

import {HTTP} from '../../_helper/http-constants.js';

export default {

name:"Login",

data(){

return{

email:"",
password:"",
showPassword:false,
showWelcome:false,
isProcessing:false,
user:{}

};

},

methods:{

async loginUser(){

if(this.isProcessing) return;

this.isProcessing=true;

try{

const response =
await HTTP.post(
"/auth/login",
{
email:this.email,
password:this.password,
device_type:"web",
fcm_id:null
});

const user={

user_id: response.data.user.id,
name: response.data.user.name,
email: response.data.user.email,
profile_image: response.data.user.profile_image,
role: response.data.user.role,
device_type: response.data.user.device_type

};

localStorage.setItem(
'user',
JSON.stringify(user)
);

localStorage.setItem(
"token",
response.data.token
);

window.dispatchEvent(
new Event('user-logged-in')
);

this.user=user;

this.showWelcome=true;

setTimeout(()=>{

const redirect =
this.$route.query.redirect;

if(redirect){

window.location.href=redirect;

}else{

window.location.href="/home";

}

},2600);

}
catch(error){

alert(
error.response?.data?.message ||
"Invalid Email or Password"
);

}
finally{

this.isProcessing=false;

}

}

}

}

</script>

<style>

.login-page{

min-height:100vh;

display:flex;

justify-content:center;

align-items:center;

background:

radial-gradient(circle at 25% 25%,#0f5c7a,transparent),
radial-gradient(circle at 80% 70%,#021a2d,transparent),
#000;

font-family:system-ui;

}

.login-card{

width:420px;

padding:50px 45px;

border-radius:22px;

background:

rgba(0,0,0,.75);

backdrop-filter:blur(20px);

color:white;

box-shadow:

0 0 80px rgba(42,164,214,.15);

border:

1px solid rgba(42,164,214,.25);

animation:popup .4s;

}

.logo-section{

text-align:center;

margin-bottom:15px;

}

.logo{

width:90px;

filter:
drop-shadow(0 0 10px #2aa4d6);

}

.title{

text-align:center;

margin-top:10px;

font-weight:500;

color:#8edcff;

}

.subtitle{

text-align:center;

opacity:.6;

font-size:14px;

margin-bottom:25px;

}

.input-group{

margin-bottom:18px;

}

.input-group label{

font-size:12px;

opacity:.6;

}

.input-group input{

width:100%;

padding:14px;

border-radius:10px;

border:none;

background:

rgba(255,255,255,.06);

color:white;

margin-top:6px;

}

.input-group input:focus{

outline:none;

box-shadow:
0 0 0 1px #2aa4d6;

}

.password-box{

position:relative;

}

.eye{

position:absolute;

right:12px;

top:13px;

cursor:pointer;

opacity:.6;

}

.login-btn{

width:100%;

padding:15px;

border-radius:12px;

border:none;

background:

linear-gradient(
90deg,
#2aa4d6,
#0f5c7a
);

color:white;

font-size:16px;

cursor:pointer;

margin-top:10px;

transition:.3s;

}

.login-btn:hover{

transform:translateY(-2px);

box-shadow:
0 12px 30px rgba(42,164,214,.35);

}

.auth-links{

margin-top:25px;

display:flex;

justify-content:space-between;

font-size:14px;

}

.auth-links a{

color:#8edcff;

text-decoration:none;

opacity:.8;

}

.auth-links a:hover{

opacity:1;

}

/* SUCCESS MODAL */

.welcome-overlay{

position:fixed;

inset:0;

background:

radial-gradient(circle,#021524,#000);

display:flex;

justify-content:center;

align-items:center;

z-index:99999;

animation:fade .4s;

}

.welcome-card{

width:420px;

padding:55px 40px;

border-radius:24px;

text-align:center;

background:

linear-gradient(180deg,#021a2d,#01060b);

border:

1px solid rgba(42,164,214,.3);

box-shadow:

0 0 100px rgba(42,164,214,.2);

animation:popup .5s;

}

.avatar-ring{

width:110px;

height:110px;

margin:auto;

padding:4px;

border-radius:100%;

background:

linear-gradient(140deg,#2aa4d6,#0f5c7a);

animation:pulse 2s infinite;

}

.welcome-avatar{

width:100%;

height:100%;

border-radius:100%;

object-fit:cover;

}

.success-icon{

margin-top:15px;

}

.success-icon svg{

width:60px;

stroke:#2aa4d6;

stroke-width:3;

fill:none;

}

.success-icon circle{

stroke-dasharray:160;

stroke-dashoffset:160;

animation:circle .7s forwards;

}

.success-icon path{

stroke-dasharray:50;

stroke-dashoffset:50;

animation:path .5s .7s forwards;

}

.welcome-title{

margin-top:15px;

color:#8edcff;

}

.welcome-user{

margin-top:5px;

font-weight:500;

}

.welcome-text{

opacity:.7;

margin-top:15px;

line-height:1.5;

}

.progress{

height:6px;

border-radius:20px;

background:#021524;

margin-top:25px;

overflow:hidden;

}

.progress-fill{

height:100%;

width:0;

background:

linear-gradient(90deg,#2aa4d6,#66e0ff);

animation:load 2.6s forwards;

}

.redirect-text{

margin-top:15px;

font-size:13px;

opacity:.6;

}

/* ANIMATIONS */

@keyframes popup{

from{
transform:scale(.7);
opacity:0;
}

to{
transform:scale(1);
opacity:1;
}

}

@keyframes fade{

from{opacity:0}
to{opacity:1}

}

@keyframes pulse{

0%{
box-shadow:0 0 0 0 rgba(42,164,214,.5);
}

70%{
box-shadow:0 0 0 18px rgba(42,164,214,0);
}

100%{
box-shadow:0 0 0 0 rgba(42,164,214,0);
}

}

@keyframes circle{

to{stroke-dashoffset:0}

}

@keyframes path{

to{stroke-dashoffset:0}

}

@keyframes load{

to{width:100%}

}

.btn-processing{
display:flex;
align-items:center;
justify-content:center;
gap:8px;
}

.btn-processing:before{

content:'';

width:14px;
height:14px;

border:2px solid rgba(255,255,255,.3);

border-top:2px solid white;

border-radius:50%;

animation:btnSpin .6s linear infinite;

}

.login-btn:disabled{

opacity:.7;
cursor:not-allowed;

}

@keyframes btnSpin{

to{
transform:rotate(360deg);
}

}

</style>